import { isNil } from "ramda";

import { DELETE_PROPERTY_PREFIX } from "../constants/general";
import { GenericFunction } from "../types/generic.types";

export const refineCamelCaseText = (text: string) => {
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
};

export const refineText = (text: string) => {
  const result = text.replace(/(\[\d\])/g, (val) => ` (${+val[1] + 1})`);
  return result.replace(/\./g, " ");
};

export const removePrefix = (field: string): string => {
  let replacedField = field;
  if (field.startsWith(DELETE_PROPERTY_PREFIX)) replacedField = field.replace(DELETE_PROPERTY_PREFIX, "");
  const splitField = replacedField?.split(".");
  if (splitField.length > 0) return splitField[0];
  return replacedField;
};

export const isRAI18Text = (text: string) => text.startsWith("ra.");

export const handleRAI18Error = (error: { field: string; message: string }, translate: any): string => {
  const { field, message } = error;
  return `${refineText(field)} is ${translate(message)}`;
};

export const handleObjectError = (error: Record<string, any>, translate: GenericFunction): string => {
  const { field, message, args } = error;
  const translatedMessage = translate(message);
  const result: RegExpExecArray | null = /%{.*}/.exec(translatedMessage);
  if (!isNil(result) && result.length > 0) {
    const fieldToReplace = result[0].slice(2, -1);
    return `${removePrefix(field)} ${translatedMessage.replace(/%{.*}/, args[fieldToReplace])}`;
  }
  return "";
};

export const getErrorMessage = (error: any, field: string, translate: any) => {
  return typeof error === "object"
    ? refineCamelCaseText(handleObjectError({ ...error, field }, translate))
    : typeof error === "string" && isRAI18Text(error)
    ? refineCamelCaseText(handleRAI18Error({ field, message: error }, translate))
    : refineCamelCaseText(error.toString());
};

export const composeValidators: (...validators: any) => any =
  (...validators) =>
  (value: any) =>
    validators.reduce((error: any, validator: any) => error || validator(value), undefined);
